import React from 'react';
import classNames from 'classnames';
import { ExternalLink, Trulyinbox } from '@saleshandy/icons';

import { OverlayTooltip } from '../../../../../../../shared/design-system/components/overlay';

const getTrulyInboxWarmupSettingsBase = () => {
  const base = process.env.REACT_APP_TRULYINBOX_URL || '';
  return base.endsWith('/warmup') ? base : `${base.replace(/\/$/, '')}/warmup`;
};

type WarmUpDailySendingLimitRowProps = {
  warmupDetails?: {
    availableQuota: number;
    Id: number;
    tiEmailAccountId: number;
    maximumSendingLimit: number;
  } | null;
};

const WarmUpDailySendingLimitRow: React.FC<WarmUpDailySendingLimitRowProps> = ({
  warmupDetails,
}) => {
  const hasWarmup = warmupDetails && warmupDetails.Id != null;

  const rowClasses = classNames(['warm-up-emails-row', 'align-items-center']);

  const openTrulyInboxSettings = () => {
    if (warmupDetails?.Id) {
      window.open(
        `${getTrulyInboxWarmupSettingsBase()}/${
          warmupDetails.tiEmailAccountId
        }/warmup-setting`,
        '_blank',
        'noopener,noreferrer',
      );
    }
  };
  const onConnectTrulyInbox = () => {
    window.open(
      `${getTrulyInboxWarmupSettingsBase()}/login`,
      '_blank',
      'noopener,noreferrer',
    );
  };

  return (
    <div className={rowClasses}>
      <div className="col-md-8">
        <div className="d-flex align-items-center gap-2 mb-1">
          <p className="total-number-title mb-0">
            Total warm-up emails per day
          </p>
          <button
            type="button"
            className="trulyinbox-badge sending-settings-trulyinbox-badge padding-left-5"
            onClick={hasWarmup ? openTrulyInboxSettings : onConnectTrulyInbox}
            aria-label="Open TrulyInbox warm-up settings"
          >
            <Trulyinbox className="icon-trulyinbox" />
            {hasWarmup ? (
              <span>
                Truly<b>Inbox</b>
              </span>
            ) : (
              <span>
                Connect Truly<b>Inbox</b>
              </span>
            )}
            <ExternalLink
              className="trulyinbox-badge-external-icon"
              aria-hidden
            />
          </button>
        </div>
        <p className="total-number-caption m-0">
          Maximum number of warm-up emails sent via this email account per day
          using TrulyInbox.
        </p>
      </div>
      <div className="warm-up-limit-value-col">
        {hasWarmup ? (
          <div className="warm-up-not-connected-placeholder">
            <span className="warm-up-limit-value" aria-hidden>
              {warmupDetails.maximumSendingLimit || '—'}
            </span>
            <OverlayTooltip text="Visit TrulyInbox to adjust your warm-up email limit.">
              <button
                type="button"
                className="warm-up-not-connected-link-block"
                onClick={
                  warmupDetails.maximumSendingLimit
                    ? openTrulyInboxSettings
                    : onConnectTrulyInbox
                }
                aria-label="Connect TrulyInbox"
              >
                <ExternalLink
                  className="warm-up-not-connected-link-icon"
                  aria-hidden
                />
              </button>
            </OverlayTooltip>
          </div>
        ) : (
          <div className="warm-up-not-connected-placeholder">
            <span className="warm-up-not-connected-dash" aria-hidden>
              —
            </span>
            <OverlayTooltip text="Connect TrulyInbox to adjust your warm-up email limit.">
              <button
                type="button"
                className="warm-up-not-connected-link-block"
                onClick={onConnectTrulyInbox}
                aria-label="Connect TrulyInbox"
              >
                <ExternalLink
                  className="warm-up-not-connected-link-icon"
                  aria-hidden
                />
              </button>
            </OverlayTooltip>
          </div>
        )}
      </div>
    </div>
  );
};

export default WarmUpDailySendingLimitRow;
